import { render, staticRenderFns } from "./FacultiesGrid.vue?vue&type=template&id=7f19245e"
import script from "./FacultiesGrid.vue?vue&type=script&lang=js"
export * from "./FacultiesGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports